import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NoAssemblyImage from 'src/assets/images/NoAssembly.svg?react';
import { PATHS } from 'src/constants/paths';

import { EmptyAssemblyProps } from './EmptyAssembly.interface';
import { Header, TextArea, Wrapper } from './EmptyAssembly.styled';

export const EmptyAssembly = (props: EmptyAssemblyProps) => {
  const {
    image: ImageComponent = NoAssemblyImage,
    showButton,
    message,
  } = props;

  const navigate = useNavigate();

  return (
    <Wrapper>
      <ImageComponent />
      <TextArea>
        <Header variant="h3">{message}</Header>
        {showButton && (
          <>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                navigate({
                  pathname: PATHS.ASSEMBLY_ADD,
                });
              }}>
              New assembly
            </Button>
          </>
        )}
      </TextArea>
    </Wrapper>
  );
};
